import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <div className="min-h-screen bg-background">
      <main className="max-w-3xl mx-auto px-4 py-12 sm:py-16">
        <Link to="/search" className="text-sm text-muted-foreground hover:text-foreground hover:underline">
          ← Back to Search
        </Link>
        <h1 className="text-3xl sm:text-4xl font-heading font-bold text-foreground">
          Terms &amp; Conditions – Vexi
        </h1>

        <p className="mt-3 text-sm text-muted-foreground">Last updated: April 2026</p>

        <div className="mt-8 space-y-5 text-foreground/90 leading-relaxed">
          <p>
            <strong>Terms &amp; Conditions – Vexi</strong>
          </p>

          <p>By using Vexi, you agree to the following terms.</p>

          <hr className="border-border" />

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">1. What Vexi Is</h2>
            <p>
              Vexi is a community-driven platform where users share and discover prices from local
              stores.
            </p>
            <p>We do not guarantee that any price is accurate, complete, or up to date.</p>
          </section>

          <hr className="border-border" />

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">2. User Responsibilities</h2>
            <p>By using Vexi, you agree to:</p>
            <ul className="list-disc pl-6 space-y-1 text-foreground/90">
              <li>Provide accurate and honest information</li>
              <li>Upload real and relevant photos</li>
              <li>Not submit fake, misleading, or harmful content</li>
              <li>Not abuse or spam the platform</li>
            </ul>
            <p>We reserve the right to remove content or restrict accounts that violate these rules.</p>
          </section>

          <hr className="border-border" />

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">3. No Guarantees</h2>
            <p>Prices shown on Vexi are user-submitted.</p>
            <p>We do not guarantee:</p>
            <ul className="list-disc pl-6 space-y-1 text-foreground/90">
              <li>accuracy of prices</li>
              <li>availability of products</li>
              <li>validity of promotions</li>
            </ul>
            <p>Always confirm prices in-store where necessary.</p>
          </section>

          <hr className="border-border" />

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">4. Content Ownership</h2>
            <p>
              You retain ownership of content you submit, but grant Vexi the right to use, display,
              and distribute it within the platform.
            </p>
          </section>

          <hr className="border-border" />

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">5. Limitation of Liability</h2>
            <p>Vexi is provided “as is”.</p>
            <p>We are not responsible for:</p>
            <ul className="list-disc pl-6 space-y-1 text-foreground/90">
              <li>incorrect prices</li>
              <li>decisions made based on the platform</li>
              <li>any loss or damage resulting from use</li>
            </ul>
          </section>

          <hr className="border-border" />

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">6. Account &amp; Access</h2>
            <p>We may suspend or terminate accounts that violate these terms.</p>
          </section>

          <hr className="border-border" />

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">7. Changes to the Service</h2>
            <p>We may update or modify the platform at any time without notice.</p>
          </section>

          <hr className="border-border" />

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">8. Changes to Terms</h2>
            <p>
              We may update these terms from time to time. Continued use means you accept the
              updated terms.
            </p>
          </section>

          <hr className="border-border" />

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">9. Contact</h2>
            <p>For any questions or issues, contact:</p>
            <p>
              <a className="text-primary hover:underline" href="mailto:support@vexi.co.za">
                support@vexi.co.za
              </a>
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}

